import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { problems } from '../../data/problems';
export function Problems() {
  return <section aria-labelledby="problems-title" className="bg-ink py-20 text-white lg:py-24" data-id="element-250" data-mp="1d066xfzurfk6">
      <div className="mx-auto max-w-page px-5 lg:px-8" data-id="element-251" data-mp="1hyziv3zhqyi8">
        <SectionHeading id="problems-title" eyebrow="Sound familiar?" lead="Teaching handball is fun." highlight="Planning it from scratch isn’t." data-id="element-252" data-mp="1hyhhjsxz1u3g" />

        <ul className="mt-12 grid gap-4 md:grid-cols-2 md:gap-5" data-id="element-253" data-mp="patyiiccnbix">
          {problems.map(problem => <li key={problem.title} className="flex gap-4 rounded-xl border border-[#24435F] bg-card p-6 sm:p-7" data-id="element-254" data-mp="u83wwnhpuxiw">
              <span aria-hidden="true" className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-2 border-alert text-alert" data-id="element-255" data-mp="z282p3f8wzie">
                <XIcon className="h-5 w-5" strokeWidth={2.75} data-id="element-256" data-mp="6hq6f1es56qf" />
              </span>
              <div data-id="element-257" data-mp="66h2lhhmhwlr">
                <h3 className="font-display text-[24px] font-bold uppercase leading-tight" data-id="element-258" data-mp="6938lcov841v">{problem.title}</h3>
                <p className="mt-2 text-base leading-relaxed text-white/75" data-id="element-259" data-mp="3smtoevp1c01a">{problem.text}</p>
              </div>
            </li>)}
        </ul>

        <p className="mx-auto mt-14 max-w-3xl text-center font-display text-[30px] font-bold uppercase leading-[1.05] text-gold sm:text-[40px]" data-id="element-260" data-mp="3nn7bknd4clt0">
          What if your next lesson was already planned before you reached the gym?
        </p>
      </div>
    </section>;
}